let _ = t => t,
    _t,
    _t2,
    _t3;

import styled, { css } from 'styled-components';
import { GYPSUM } from 'HubStyleTokens/colors';
import { H2 } from 'UIComponents/elements/headings';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
export const Section = styled.div.withConfig({
  displayName: "SplashPageSharedComponents__Section",
  componentId: "le535z-0"
})(["width:100%;display:flex;justify-content:center;align-items:center;flex-direction:column;position:relative;padding:16px 0 60px;overflow:hidden;", ""], ({
  use
}) => {
  if (use === 'shaded') {
    return css(["background-color:", ";"], GYPSUM);
  }

  return null;
});
export const Container = styled.div.withConfig({
  displayName: "SplashPageSharedComponents__Container",
  componentId: "le535z-1"
})(["max-width:1130px;margin:auto;width:100%;padding:0 40px;"]);
export const SectionHeader = styled.div.withConfig({
  displayName: "SplashPageSharedComponents__SectionHeader",
  componentId: "le535z-2"
})(["max-width:850px;margin:20px auto;"]);
export const SectionTitle = styled(H2).withConfig({
  displayName: "SplashPageSharedComponents__SectionTitle",
  componentId: "le535z-3"
})(["text-align:center;margin-bottom:8px;font-weight:600;"]);
export const SectionSubTitle = styled.div.withConfig({
  displayName: "SplashPageSharedComponents__SectionSubTitle",
  componentId: "le535z-4"
})(["text-align:center;margin-bottom:24px;"]);
export const ProductLineIcon = styled(UIFlex).withConfig({
  displayName: "SplashPageSharedComponents__ProductLineIcon",
  componentId: "le535z-5"
})(["margin-left:12px;margin-right:12px;", " ", ""], breakpoint.tabletPortrait(_t || (_t = _`
    flex-direction: column;
    align-items: center;
  `)), breakpoint.phoneLarge(_t2 || (_t2 = _`
    align-items: start;
    margin: 6px auto;
    flex-direction: row;
  `)));
export const IconImage = styled(UIImage).withConfig({
  displayName: "SplashPageSharedComponents__IconImage",
  componentId: "le535z-6"
})(["height:24px;", ""], breakpoint.phoneLarge(_t3 || (_t3 = _`
    height: 16px;
  `)));